/* src/app/shared/components/consolidation-filter-panel/consolidation-filter-panel.component.scss */
button.search {
  background-color: #E86D0C;
  border-radius: 5px;
  border: 0;
  height: 40px;
}
button.search i {
  color: #FFFFFF;
  padding: 2px;
}
button.clear {
  min-width: 0;
}
button.search:disabled {
  background-color: #D8D8D8;
}
/*# sourceMappingURL=consolidation-filter-panel.component.css.map */
